import { render, staticRenderFns } from "./avater.vue?vue&type=template&id=184a0386&scoped=true&"
import script from "./avater.vue?vue&type=script&lang=js&"
export * from "./avater.vue?vue&type=script&lang=js&"
import style0 from "./avater.vue?vue&type=style&index=0&id=184a0386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a0386",
  null
  
)

export default component.exports